import React from 'react'
import { UIButton, type UIButtonProps } from './ui-button'
import { Loader } from 'lucide-react'

export interface UIButtonLoadingProps extends Omit<UIButtonProps, 'children'> {
  loading?: boolean
  children?: React.ReactNode
}

/**
 * Loading Button Component
 * Based on official shadcn button-06 block
 * Use for async operations like save, submit, fetch
 */
export const UIButtonLoading = React.forwardRef<HTMLButtonElement, UIButtonLoadingProps>(
  ({ loading = false, disabled, children, ...props }, ref) => {
    return (
      <UIButton
        disabled={disabled || loading}
        ref={ref}
        {...props}
      >
        {loading && <Loader className="animate-spin h-4 w-4" />}
        {children}
      </UIButton>
    )
  }
)

UIButtonLoading.displayName = "UIButtonLoading"